import { observer } from "mobx-react"

import ButtonBg from "./button-bg.svg"
import ButtonBgMobile from "./button-bg-mobile.svg"

type CtaButtonProps = {
  text: string
  rotation?: number
}

const Component = ({ text, rotation = 0 }: CtaButtonProps) => {
  return (
    <button
      className="group relative cursor-pointer select-none w-[245px] laptop:w-[340px]"
      style={{ rotate: `${rotation}deg` }}
    >
      <p className="m-0 p-0 absolute z-1 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-white font-sans-bold text-[14px] laptop:text-[20px] tracking-[0.5px] leading-[18px] laptop:leading-[28px] whitespace-nowrap">
        {text}
      </p>
      <ButtonBg
        viewBox="0 0 326 88"
        className="hidden laptop:block w-full h-auto text-black group-hover:text-[#333] transition-colors duration-150"
      />
      <ButtonBgMobile
        viewBox="0 0 231 70"
        className="block laptop:hidden w-full h-auto  text-black group-hover:text-[#333] transition-colors duration-150"
      />
    </button>
  )
}

const CtaButton = observer(Component)

export { CtaButton }
